import { AccessibeWidget } from './accessibility/Accessibe';
import FeatureFlags from '../constants/FeatureFlags';

export default function AccessibilityWidget() {
  if (!FeatureFlags.ACCESSIBILITY_WIDGET) return null;

  return <AccessibeWidget />;
}
